import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { MessageFrame } from './MessageFrame';
import { MessageScrollArea } from './MessageScrollArea';
import { ProposalActionsRow } from './ProposalActionsRow';
import { ProposalItemCard } from './ProposalItemCard';
import { ProposalItemCheckbox } from './ProposalItemCheckbox';
import scrollAreaStyles from './scrollArea.module.scss';
export const GetConfirmationSummaryMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ConfirmationSummaryMessage = (param)=>{
    let { content, messageId, interactive, onDismiss, onApply, onSubmitFeedback, onDismissFeedback } = param;
    const { ConfirmationSummaryMessageTID } = useMemo(()=>GetConfirmationSummaryMessageTID(messageId), [
        messageId
    ]);
    const [itemChecked, setItemChecked] = useState(()=>{
        const initial = {};
        content.items.forEach((i)=>initial[i.id] = i.checked);
        return initial;
    });
    const toggleItem = (itemId)=>setItemChecked((prev)=>_object_spread_props(_object_spread({}, prev), {
                [itemId]: !prev[itemId]
            }));
    const allItemIds = content.items.map((i)=>i.id);
    const selectedItemIds = allItemIds.filter((id)=>itemChecked[id]);
    const isCards = content.renderKind === 'cards';
    const renderItem = (item)=>'groups' in item ? /*#__PURE__*/ _jsx(ProposalItemCard, {
            item: item,
            checked: !!itemChecked[item.id],
            disabled: !interactive,
            onChange: ()=>toggleItem(item.id),
            testId: ConfirmationSummaryMessageTID.Item(item.id)
        }, item.id) : /*#__PURE__*/ _jsx(ProposalItemCheckbox, {
            item: item,
            checked: !!itemChecked[item.id],
            disabled: !interactive,
            onChange: ()=>toggleItem(item.id),
            testId: ConfirmationSummaryMessageTID.Item(item.id)
        }, item.id);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        width: "100%",
        className: scrollAreaStyles.fillSlot,
        children: [
            /*#__PURE__*/ _jsxs(MessageFrame, {
                testId: ConfirmationSummaryMessageTID.Root(),
                padding: "16px 0 0 0",
                fillHeight: true,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: ConfirmationSummaryMessageTID.Intro(),
                        className: scrollAreaStyles.framePad,
                        children: content.intro
                    }),
                    /*#__PURE__*/ _jsx(MessageScrollArea, {
                        testId: ConfirmationSummaryMessageTID.Items(),
                        gap: 8,
                        children: isCards ? /*#__PURE__*/ _jsx(Row, {
                            gap: 8,
                            width: "100%",
                            testId: ConfirmationSummaryMessageTID.CardsRow(),
                            children: content.items.map(renderItem)
                        }) : content.items.map(renderItem)
                    }),
                    interactive && /*#__PURE__*/ _jsx(ProposalActionsRow, {
                        className: scrollAreaStyles.frameFooter,
                        selectedCount: selectedItemIds.length,
                        applySelectedLabel: content.applySelectedLabel,
                        applyAllLabel: content.applyAllLabel,
                        dismissLabel: content.dismissLabel,
                        applySelectedDisabled: selectedItemIds.length === 0,
                        onApplySelected: ()=>onApply(messageId, selectedItemIds),
                        onApplyAll: ()=>onApply(messageId, allItemIds),
                        onDismiss: ()=>onDismiss(messageId),
                        dismissTestId: ConfirmationSummaryMessageTID.Dismiss(),
                        applySelectedTestId: ConfirmationSummaryMessageTID.ApplySelected(),
                        applyAllTestId: ConfirmationSummaryMessageTID.ApplyAll()
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
